var React = require('react');

function IcAppsDesktop (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"y":"37","width":"48","height":"8","rx":"3","fill":"#d4e0ec","key":0}),React.createElement("rect",{"x":"2","y":"4","width":"44","height":"32","rx":"4","fill":"#d4e0ec","key":1}),React.createElement("rect",{"x":"5","y":"7","width":"38","height":"26","rx":"2","fill":"#a3b5ca","key":2}),React.createElement("rect",{"x":"3","y":"36","width":"42","height":"5","rx":"2","fill":"#a3b5ca","key":3})]);
}

IcAppsDesktop.defaultProps = {"id":"ic-apps-desktop","viewBox":"0 0 48 48","fill":"none"};

module.exports = IcAppsDesktop;

IcAppsDesktop.default = IcAppsDesktop;
